import { useTranslation } from 'react-i18next';
import { IconNameType, QBox, QButton, QIcon } from '@qualio/ui-components';
import DeleteCardButton from './DeleteCardButton';

type Props = {
  onMove: (direction: 'up' | 'down') => void;
  onDelete: () => void;
  disableUp?: boolean;
  disableDown?: boolean;
  disableDelete?: boolean;
  'data-cy'?: string;
  removeIcon?: Extract<IconNameType, 'Trash' | 'X'>;
  disabledDeleteTooltip?: string;
};

const ListMovementControls = (props: Props) => {
  const { t } = useTranslation();
  const {
    onMove,
    onDelete,
    disableUp = false,
    disableDown = false,
    disableDelete = false,
    removeIcon = 'Trash',
    disabledDeleteTooltip = '',
  } = props;

  return (
    <QBox display="flex" flexDirection="row" justifyContent="space-between">
      <QButton
        aria-label={t('common.labels.moveUp')}
        data-cy={`move-up-${props['data-cy']}`}
        variant="ghost"
        onClick={() => onMove('up')}
        isDisabled={disableUp}
      >
        <QIcon iconName="ArrowUp" />
      </QButton>
      <QButton
        aria-label={t('common.labels.moveDown')}
        data-cy={`move-down-${props['data-cy']}`}
        variant="ghost"
        onClick={() => onMove('down')}
        isDisabled={disableDown}
      >
        <QIcon iconName="ArrowDown" />
      </QButton>
      <DeleteCardButton
        onDelete={onDelete}
        dataCy={`delete-${props['data-cy']}`}
        disableDelete={disableDelete}
        removeIcon={removeIcon}
        disabledDeleteTooltip={disabledDeleteTooltip}
      />
    </QBox>
  );
};

export default ListMovementControls;
